module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/new_photo_04@2x-a0c1f5b64aecfa228135f6fab65f5a17.jpg";